import React from 'react'
import { useDispatch } from 'react-redux'

import { sendMessages } from 'ducks/concurrency'
import { useModal, useSnackbar } from 'hooks'

const useSendTestsInvitationsMutations = () => {
  const dispatch = useDispatch()

  const handleSendReminders = React.useCallback(
    ({ candidates, projectId }, { onShowSnackbar, onSuccess }) => {
      dispatch(
        sendMessages({ candidates, projectId }, { onShowSnackbar, onSuccess }),
      )
    },
    [dispatch],
  )

  return {
    handleSendReminders,
  }
}

export const useSendTestsRemindersModal = (state, handlers) => {
  const { projectId } = state
  const { handleSetCandidate } = handlers

  const handleReset = React.useCallback(() => {
    handleSetCandidate(null)
  }, [handleSetCandidate])

  const { handleClose, handleOpen, isOpen } = useModal()

  const {
    handlers: { handleShowSnackbar },
  } = useSnackbar()

  const { handleSendReminders } = useSendTestsInvitationsMutations()

  const handleSendTestsRemindersModalClose = React.useCallback(() => {
    handleClose()
    handleReset()
  }, [handleClose, handleReset])

  const handleSendTestsRemindersModalConfirm = React.useCallback(
    ({ candidates }, { onSuccess }) => {
      handleSendReminders(
        { candidates, projectId },
        {
          onShowSnackbar: handleShowSnackbar,
          onSuccess: () => {
            onSuccess()
            handleReset()
          },
        },
      )
      handleClose()
    },
    [
      projectId,
      handleClose,
      handleReset,
      handleSendReminders,
      handleShowSnackbar,
    ],
  )
  return {
    handleSendTestsRemindersModalClose,
    handleSendTestsRemindersModalConfirm,
    handleSendTestsRemindersModalOpen: handleOpen,
    isSendTestsRemindersModalOpen: isOpen,
  }
}
